module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAcUlEQVR42u3QQREAMQACMSzUxPlXUkv0dSoIMyuApG2Wmz4PAAAAAAAAAAAAAECbe74uBQAAAAAAAAAAAAAAAAB/awMAAAAAAAAAAAAAAACAJkmXAgAAAAAAAAAAAAAAAAAAywEAAAAAAAAAAAAAMNoDhH5bQFdCNZkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Yemen.png
// module id = Wm0P
// module chunks = 0 62 63